import { Injectable } from "@angular/core";
import { PushNotificationsService } from "@app/core/notifications/domain/push-notifications.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class InitPushNotificationsUseCase {
  constructor(private pushService: PushNotificationsService) {}

  execute(): void {
    this.pushService.init(environment.ONE_SIGNAL_ID);
    this.pushService.requestPermissions().subscribe();
    this.pushService.enableNotifications();
  }
}
